import { CSSProperties } from "react";
import FaceProfilePreviewView from "./FaceProfilePreviewView";
import { useOne } from "@refinedev/core";
import { FaceProfileResponse } from "../types";

export const FaceProfilePreview = ({
  id,
  assetId,
  assetPath,
  name,
  style,
  onClick,
  ghost,
  selected,
  fullSize,
  className,
}: {
  id?: string;
  assetId?: string;
  assetPath?: string;
  name?: string;
  style?: CSSProperties;
  onClick?: () => void;
  ghost?: boolean;
  selected?: boolean;
  fullSize?: boolean;
  className?: string;
}) => {
  const { data } = useOne<FaceProfileResponse>({
    resource: `media/face_profiles`,
    id,
    queryOptions: {
      enabled: !!id && !assetPath,
      refetchInterval(data) {
        // check until we have a path to show
        return data?.data.category === "Premade"
          ? false
          : data?.data.extracted_asset_path || data?.data.custom_asset_path
            ? false
            : 3000;
        // 3s
      },
    },
    errorNotification() {
      return false;
    }, // hide errors
  });
  const isProcessing = !data?.data && !assetId && !assetPath;
  const path =
    data?.data.thumbnail_asset_path ??
    data?.data.extracted_asset_path ??
    data?.data.custom_asset_path ??
    assetPath;
  return (
    <FaceProfilePreviewView
      className={className}
      name={name}
      path={assetPath ?? path}
      style={style}
      onClick={onClick}
      isProcessing={isProcessing}
      selected={selected}
      ghost={isProcessing}
      fullSize={fullSize}
    />
  );
};
